export default __webpack_public_path__ + "static/media/product4.164646ff.png";